import React from 'react';
import { connect } from 'react-redux';
import { hospitalSingleFetch, hospitalSingleDelete } from '../../lib/redux/actions/hospitals';
import { addToast } from '../../lib/redux/actions/toast';
import HospitalSingle from './HospitalSingle';
import * as ROUTES from '../../lib/routing/frontend';

const mapStateToProps = (state) => ({
  ...state.hospitals,
});

const mapDispatchToProps = {
  hospitalSingleFetch,
  hospitalSingleDelete,
  addToast,
};

class HospitalSingleContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDeleting: false,
    };
  }

  componentDidMount() {
    const hospitalId = this.props.match.params.id;
    this.props.hospitalSingleFetch(hospitalId);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      const hospitalId = this.props.match.params.id;
      this.props.hospitalSingleFetch(hospitalId);
    }
  }

  deleteHospital = async () => {
    if (!this.state.isDeleting) {
      this.setState({ isDeleting: true });
      return;
    }

    try {
      const hospitalId = this.props.match.params.id;
      await this.props.hospitalSingleDelete(hospitalId);
      this.props.addToast('Hospital deleted successfully', true, false);
      this.props.history.push(ROUTES.HOSPITALS.ALL.replace('/:page', ''));
    } catch (error) {
      this.setState({ isDeleting: false });
      // Display specific error message from API or fallback to generic message
      const errorMessage = error?.errors?._error || 'Failed to delete hospital. Please try again.';
      this.props.addToast(errorMessage, false, true);
    }
  };

  render() {
    const canDeleteHospital =
      (!this.props.hospital?.hospitalConsultants || this.props.hospital.hospitalConsultants.length < 1) &&
      (!this.props.hospital?.consultants || this.props.hospital.consultants.length < 1) &&
      (!this.props.hospital?.invoiceBatchCount || this.props.hospital.invoiceBatchCount < 1) &&
      (!this.props.hospital?.invoiceCount || this.props.hospital.invoiceCount < 1);

    return (
      <HospitalSingle
        hospital={this.props.hospital}
        canDeleteHospital={canDeleteHospital}
        deleteHospital={this.deleteHospital}
        isDeletingHospital={this.state.isDeleting}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HospitalSingleContainer);
